import styled from "styled-components";
import Variables from "../../assets/styleVariables";

export const MoreMenuContainer = styled.div`
  z-index: 9999;
  position: absolute;
  left: 20px;
  top: 30px;
  width: 184px;
  border-radius: 4px;
  padding: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  -webkit-box-shadow: 0 2px 6px 0 #cccccc;
  -moz-box-shadow: 0 2px 6px 0 #cccccc;
  box-shadow: 0 2px 6px 0 #cccccc;
  background-color: ${Variables.colors.complementary};
`;

const TYPES = {
  warning: Variables.colors.yellow_400,
  error: Variables.colors.red_600,
  second: Variables.colors.complementary_700
};
export const Item = styled.div`
  width: 100%;
  height: 36px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;
  padding: 0 16px;
  .item-text {
    font-size: ${Variables.font_sizes.medium};
    color: ${Variables.colors.complementary_900};
  }
  .item-icon {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 10px;
    &:before {
      margin: 0;
      font-size: 12.5px;
      color: ${props => (props.type ? TYPES[props.type] : TYPES["second"])};
    }
  }
  &:hover {
    background-color: ${Variables.colors.complementary_300};
  }
`;
